import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesGetReadyFullEnum } from 'src/app/get-ready-full/shared/enums/routes-get-ready-enum';
import { GetReadyCommonFullService } from 'src/app/get-ready-full/shared/get-ready-common.service';
import { GetReadyFormFullService } from 'src/app/get-ready-full/shared/get-ready-form.service';
import { Analytics } from '../../shared/analytics';
import { AdminListEnum } from '../../shared/services/admin-lists/enum/admin-list.enum';
import { OffersFullModel } from '../models/offers-model';
import { RoutesOffersFullEnum } from '../shared/enums/routes-offers-enum';
import { OffersFullCommonService } from '../shared/offers-common.service';
import { OffersFullNavigationService } from '../shared/offers-navigation.service';



@Component({
  selector: 'offers-benefits-comissions',
  templateUrl: './benefits-comissions.component.html',
  styleUrls: ['../shared/offers-styles.scss', './benefits-comissions.component.scss']
})
export class BenefitsCommissionsFullComponent implements OnInit, OnDestroy {

  pageId = 'benefits-comissions';
  offersModel: OffersFullModel;
  selectedOffer: number;
  externalUrl: string;
  body = document.querySelector('body');
  hyperlinkBehavior: string;
  modalShow = false;

  constructor(
    public offersCommonService: OffersFullCommonService,
    private route: Router,
    private navigationService: OffersFullNavigationService,
    private getReadyFormService: GetReadyFormFullService,
    private getReadyCommonService: GetReadyCommonFullService,
    private analyticsLib: Analytics) {
  }

  ngOnInit() {
    this.navigationService.setStage(RoutesOffersFullEnum.BENEFITS_COMISSIONS);
    this.setData();
    this.offersCommonService.scrollToTop(document);
    this.hyperlinkBehavior = this.offersCommonService.getHyperlinkBehavior();
    this.analyticsLib.buildData('BeneficiosCondiciones', this.pageId, null, false);
    this.analyticsLib.trackState(null, null);

  }

  setData() {
    const adminLinkURLs = this.offersCommonService.getAdminList(AdminListEnum.LIST_URLS);

    this.selectedOffer = this.getReadyFormService.getProperty('selected_package') || 0;
    this.offersModel = this.getReadyCommonService.offersResponse;
    this.externalUrl = adminLinkURLs.find(i => i.code.toUpperCase() === 'ACCOUNT_TERMS').description;
  }

  previous() {
    this.route.navigate([RoutesGetReadyFullEnum.CONTACT.toString()]);
  }

  category2icon(category) {
    const iconList = this.offersCommonService.getAdminList(AdminListEnum.ICONS);

    const icon = iconList.find(i => i.code === category);
    if (icon && icon.label) {
      return icon.label;
    }
    return 'icon-itaufonts_chat_enviado';
  }

  groupText(benefit) {
    return '<strong>'
      + benefit.title + '</strong> '
      + benefit.benefit_description;
  }

  ngOnDestroy() {
    this.body.setAttribute('style', 'background-color: white');
  }

  toggleModal() {
    this.modalShow = !this.modalShow;
  }

}
